<svelte:options tag="app-switcher" />

<div id="main" on:click={toggle} on:mouseover={iconMouseEnter} on:mouseleave={iconMouseLeave} class:hoverenabled>
  <!-- App Switcher Grid Icon -->
  <svg
    version="1.1"
    id="switcher-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="40px"
    height="40px"
    viewBox="0 0 512 512"
    style="overflow: visible; enable-background: new 0 0 512 512;"
    xml:space="preserve"
    aria-label="app switcher icon"
  >
    <style type="text/css">
      .st0 {
        fill: var(--ripe-app-header-icon-bg, #c0c0c0);
      }
    </style>
    <circle class="hover-ring" cx="256" cy="256" r="256" />
    <path
      class="st0"
      d="M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256S114.6,0,256,0S512,114.6,512,256z M358.3,188
        c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9C347.6,212,358.3,201.2,358.3,188z
        M202.5,188 c0-13.2-10.7-23.9-23.9-23.9s-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9S202.5,201.2,202.5,188z
        M280.4,188
        c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9C269.7,212,280.4,201.2,280.4,188z
        M357.6,257.3c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9
        C346.9,281.2,357.6,270.5,357.6,257.3z M201.8,257.3c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9
        c0,13.2,10.7,23.9,23.9,23.9C191.1,281.2,201.8,270.5,201.8,257.3z M279.7,257.3c0-13.2-10.7-23.9-23.9-23.9
        c-13.2,0-23.9,10.7-23.9,23.9c0,13.2,10.7,23.9,23.9,23.9C269,281.2,279.7,270.5,279.7,257.3z M358.3,326.5
        c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9s10.7,23.9,23.9,23.9C347.6,350.5,358.3,339.8,358.3,326.5z
        M202.5,326.5 c0-13.2-10.7-23.9-23.9-23.9s-23.9,10.7-23.9,23.9s10.7,23.9,23.9,23.9S202.5,339.8,202.5,326.5z
        M280.4,326.5
        c0-13.2-10.7-23.9-23.9-23.9c-13.2,0-23.9,10.7-23.9,23.9s10.7,23.9,23.9,23.9C269.7,350.5,280.4,339.8,280.4,326.5z"
    />
  </svg>

  <!-- This wrapper element determines the amount of overlap there is for hovering the app-switcher icon and the
        whitespace underneath and next to it
  -->
  <div id="apps-list-w">
    <ul id="apps-list">
      {#each sites as site}
        <li class:hoverenabled class:active={current === site.name}>
          <a href={site.url} on:click={itemClicked(site.title)}>{site.title}</a>
          <div class="indicator" />
        </li>
      {/each}
    </ul>
  </div>
</div>

<script>
  import { onMount } from 'svelte'
  import { get_current_component } from 'svelte/internal'

  const isMobile = /Mobi|Android/.test(navigator.userAgent)
  const hoverenabled = !isMobile
  const component = get_current_component()

  let show = false
  let sites = [{ title: 'Loading...', url: '#', name: '' }]

  export let current = null
  export let appenv = 'prod'

  let iconHovered = false

  onMount(() => {
    fetch(`https://www-static.ripe.net/dynamic/app-switcher/${appenv === 'pre' ? 'pre-' : ''}list.json`)
      .then(response => response.json())
      .then(json => {
        sites = json
      })
  })

  function toggle() {
    show = !show
    if (show) {
      return window.setTimeout(() => window.addEventListener('mouseout', handleClose), 0)
    }
    return window.removeEventListener('mouseout', handleClose)
  }

  function handleClose(e) {
    const clickedElemInShadowDom = e.composedPath()[0]
    const canClickWhileOpen = clickedElemInShadowDom.classList.contains('clickable')
    if (canClickWhileOpen) {
      return
    }
    toggle()
  }

  function iconMouseEnter() {
    if (!iconHovered) {
      dispatch('app-switcher-mouse-enter')
      iconHovered = true
    }
  }

  function iconMouseLeave() {
    iconHovered = false
    dispatch('app-switcher-mouse-leave')
  }

  function itemClicked(title) {
    dispatch('app-switcher-item-click', { item: title })
  }

  function dispatch(eventName, eventDetails = null) {
    const event = new CustomEvent(eventName, {
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    if (eventDetails) {
      event.details = eventDetails
    }
    component.dispatchEvent(event)
  }
</script>

<style type="text/scss">
  :host {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;
    position: relative;
    background: none;
    user-select: none;
    // pff, this should gap on the parent.
    // but chromium can't deal with it yet.
    margin-left: 1rem;
    font-family: var(--ripe-app-font-family), Helvetica, Arial, Sans-serif;
    font-weight: 600;
  }

  #main {
    position: relative;
    user-select: none;
    cursor: pointer;
    @media print {
      display: none;
    }

    &:hover circle.hover-ring {
      stroke: none;
      fill: var(--ripe-app-header-icon-hover, #080037);
      transform: scale(1.25);
      transform-origin: 256px 256px;
      transition: 0.1s transform ease-in;
    }

    &.hoverenabled:hover div#apps-list-w {
      display: block;
    }

    button {
      padding: 0;
      background: 0;
      border: 0;
    }

    &:hover div#apps-list-w {
      display: block;
    }
  }

  #switcher-icon {
    // @media only screen and (max-width: 700px) {
    //   height: 32px;
    //   width: 32px;
    // }

    width: 40px;
    height: 40px;

    circle.hover-ring {
      fill: none;
      stroke: none;
    }

    &:hover {
      cursor: pointer;
    }
  }

  div#apps-list-w.show {
    display: block;
  }

  #apps-list-w {
    display: none;
    position: absolute;
    /* the safety hover-overlap starts
    working below 'top' */
    top: 25px;
    right: -9px;
    width: 190px;
  }

  #apps-list {
    background-color: var(--ripe-app-navbar-background, #080037);
    z-index: 999999;
    list-style: none;
    padding: 0;
    margin: 0;
    margin-top: 30px;

    &:after {
      top: 10px;
      right: 18px;
      border: solid transparent;
      content: ' ';
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-bottom-color: var(--ripe-app-navbar-background, #080037);
      border-width: 10px;
      margin-left: -10px;
    }

    li {
      position: relative;
      list-style: none;
      text-align: left;
      border-bottom: 1px solid var(--ripe-app-border-line, #2f2c56);

      &.hoverenabled {
        &:hover {
          a {
            color: var(--ripe-app-navbar-menuitem, #d7dce8);
          }
          .indicator {
            opacity: 0.6;
            width: 6px;
          }
        }
      }

      &.active,
      &.active:hover {
        a {
          color: var(--ripe-app-navbar-active-menuitem, #ffffff);
        }
        .indicator {
          opacity: 1;
          width: 6px;
        }
      }

      a {
        color: var(--ripe-app-primary-20, #d7dce8);
        display: block;
        text-decoration: none;
        padding: 12px 16px 12px 20px;
      }

      .indicator {
        position: absolute;
        top: 0;
        left: 0;
        content: '';
        width: 0px;
        // because of border
        height: calc(100% + 1px);
        background: var(--ripe-app-navbar-indicator, #f59331);
        margin-bottom: 10px;
      }
    }
  }

  @media only screen and (max-width: 400px) {
    :host {
      margin-left: 0.5rem;
    }
  }
</style>
